import { useAsync } from 'react-use'

import { useAccountContext } from 'components/contexts/AccountContext'
import { CustomerAccountWithLicenses } from 'types/CustomerAccountWithLicenses'
import fetchCustomerAccounts from 'utils/fetchCustomerAccounts'
import useHasPartnerAccess from './useHasPartnerAccess'

const useCustomerAccounts = (): { loading: boolean; customerAccounts: null | CustomerAccountWithLicenses[] } => {
  const { partnerAccountKey } = useAccountContext()
  const { hasPartnerAccess } = useHasPartnerAccess()

  const { value, loading } = useAsync(() => {
    if (!partnerAccountKey || !hasPartnerAccess) {
      return Promise.resolve(null)
    }
    return fetchCustomerAccounts(partnerAccountKey).then((customerAccounts) => customerAccounts)
  }, [partnerAccountKey])

  return { customerAccounts: value, loading }
}

export default useCustomerAccounts
